import { Gateway, SingleFareOptions } from "@ssc-booking/api-contracts"

export type GatewaySelectItem = {
    code: string
    label: string
}

const gatewayLabel = (gateway: Gateway): string => `${gateway.name} (${gateway.code})`

export const gatewayNameByCode = (
    singleFareOptions: SingleFareOptions,
    gatewayCode: string | undefined,
): string | undefined => singleFareOptions.gateways.find((g) => g.code == gatewayCode)?.name

export const toGatewaySelectItems = (singleFareOptions: SingleFareOptions): GatewaySelectItem[] =>
    singleFareOptions.gateways.map((x) => ({ code: x.code, label: gatewayLabel(x) }))

export const selectDefaultGateway = (gateways: readonly Gateway[]): Gateway | undefined =>
    gateways.length > 0 ? gateways[0] : undefined
